import { hasActiveObservations as t } from "./highrise1815.mjs";
import { hasSkippedObservations as e } from "./highrise1816.mjs";
import { deliverResizeLoopError as i } from "./highrise1817.mjs";
import { broadcastActiveObservations as s } from "./highrise1818.mjs";
import { gatherActiveObservationsAtDepth as o } from "./highrise1819.mjs";
var n = function() {
  var r = 0;
  for (o(r); t(); )
    r = s(), o(r);
  return e() && i(), r > 0;
};
export {
  n as process
};
